var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-progress-linear',{attrs:{"color":_vm.getColor,"value":(_vm.qtde/_vm.qtdeTotal)*100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }